import React, { useState, useEffect } from "react";
import NewFirewallRuleModal from "./NewFirewallRuleModal";
import { useParams } from "react-router-dom";
import DeleteFirewallRuleModal from "./DeleteFirewallRuleModal";
import { Dropdown } from "react-bootstrap";
import FormatDateTime from "../../../../Functions/FormatDate";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { TbUser } from "react-icons/tb";
import NoDataItem from "../NoDataItem";
import ErrorPage from "../../../../Components/ErrorPage";

const FirewallMain = ({ instanceData, fetchRecords, records, dbName }) => {
    const { t } = useLanguage()
    const { project_id, db_id } = useParams();
    const [openNewFirewallModal, setOpenNewFirewallModal] = useState(false);
    const [firewallRules, setFirewallRules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedRecordId, setSelectedRecordId] = useState("")

    const title_empty_col = "No firewall rules available!"
    const subtitle_empty_col = "Firewall rules to grant access to this database thorugh the instance."
    const img_empty = "sqltable"

    const fetchRecordsFirewall = async () => {
        setLoading(true);
        setError("");

        try {
            const response = await fetch("https://backend.erioon.com/get_firewall_rules", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id: sessionStorage.getItem("user_id"),
                    instance_id: instanceData._id,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || "Failed to fetch firewall rules");
            } else {
                setFirewallRules(data.firewall_rules || []);
            }
        } catch (err) {
            setError("An unexpected error occurred");
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 800);
        }
    };

    const handleDelete = async (rule) => {
        setSelectedRecordId(rule)
        setShowDeleteModal(true)
    };

    useEffect(() => {
        fetchRecordsFirewall();
    }, [db_id]);

    if (loading) {

    }

    if (loading) {
        return (
            <div className="loading_users_cont"></div>
        )
    } else if (error) {
        return <ErrorPage />;
    }

    return (
        <div className="db_users_cont">

            <div className="db_users_container">
                {firewallRules.length === 0 ? (
                    <NoDataItem
                        fetchRecords={fetchRecords}
                        title={title_empty_col}
                        subtitle={subtitle_empty_col}
                        item={img_empty}
                        showBtn={true}
                        dbType={"firewallRules"}
                    />
                ) : (
                    <div className="users_cont_main">
                        <div className="db_users_container">
                            {firewallRules.map((firewall) => (
                                <div key={firewall.start_ip} className="firewall_item">
                                    <p className="firewall_name">Start IP: {firewall.start_ip}</p>
                                    <p className="firewall_name">End IP: {firewall.end_ip}</p>

                                    <div className="table_item_footer">
                                        {firewallRules.length > 1 ? (
                                            <Dropdown>
                                                <div className="property_btn_action_toggle">
                                                    <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className="custom-dropdown-menu">
                                                        <Dropdown.Item
                                                            className="drop_down_item delete"
                                                            onClick={() => handleDelete(firewall)}
                                                        >
                                                            <i className="fa-solid fa-trash"></i> {t.delete}
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </div>
                                            </Dropdown>
                                        ) : (
                                            <i className="fa-solid fa-ban fa-no-drop" title="Cannot delete the last firewall rule"></i>
                                        )}
                                    </div>
                                </div>
                            ))}

                            <div className="new_api_item" onClick={() => setOpenNewFirewallModal(true)}>
                                <i className="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>

                )}
            </div>

            <NewFirewallRuleModal
                show={openNewFirewallModal}
                handleClose={() => {
                    setOpenNewFirewallModal(false);
                }}
                fetchRecordsFirewall={fetchRecordsFirewall}
                instanceData={instanceData}
            />
            <DeleteFirewallRuleModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                instance_id={instanceData._id}
                firewall_rules={selectedRecordId}
                fetchRecordsFirewall={fetchRecordsFirewall}
                endpoint={"delete_firewall_rule"}
                record_type={"Firewall"}
                message="This action CANNOT be undone later. This access will be deleted permanently."
            />
        </div>
    );
};

export default FirewallMain;
